import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { DialogOverlay, DialogContent } from '@reach/dialog'
import { transparentize } from 'polished'
import { COLORS } from 'config/constants'
import { fontWeights, radius, space, getTransition } from 'config/theme'
import { pxToRem } from 'utils/helpers'
import { Box, Flex } from 'components/atoms/Layout'
import Button from 'components/atoms/Button'
import Transition from 'components/atoms/Transition'
import iconClose from 'assets/images/icon-close-white.svg'

const TRANSITION_TIMEOUT = 100

const Overlay = styled(DialogOverlay)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: ${space.l};
  display: flex;
  overflow-y: auto;
  background-color: ${transparentize(0.35, COLORS.POT_BLACK)};
  opacity: 0;
  transition: ${getTransition('opacity')};
  ${({ state }) => state === Transition.STATE.ENTERED && `opacity: 1;`}
`

const DialogContainer = styled(DialogContent)`
  margin: auto;
  position: relative;
  background-color: ${COLORS.WHITE};
  border-radius: ${radius.m};
  max-width: 1200px;
`

const CloseDialogCircle = styled.div`
  position: absolute;
  right: 0;
  width: ${space.l};
  height: ${space.l};
  transform: translate3d(50%, -50%, 0);
  border-radius: ${radius.pill};
  background: url("${iconClose}") center no-repeat;
  background-color: ${COLORS.GREY_OF_DARKNESS};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const Dialog = ({
  onClose,
  onClick,
  isVisible,
  title,
  body,
  buttonLabel,
  ...rest
}) => {
  const dialogEl = React.createRef()
  if (isVisible) {
    disableBodyScroll(dialogEl.current)
  } else {
    clearAllBodyScrollLocks()
  }
  return (
    <Transition
      in={isVisible}
      timeout={TRANSITION_TIMEOUT}
      mountOnEnter
      unmountOnExit
    >
      {(state) => (
        <Overlay state={state} onDismiss={onClose}>
          <DialogContainer ref={dialogEl}>
            <CloseDialogCircle onClick={onClose} />
            <Box p="l" {...rest}>
              <Box mb="l">{title}</Box>
              <Box
                width={pxToRem(120)}
                height={pxToRem(3)}
                bg={COLORS.BUTTERSCOTCH}
                m="0 auto"
              />
              <Box my="l">{body}</Box>
              <Flex justifyContent="center">
                <Button.Filled onClick={onClick} fontWeight={fontWeights.bold}>
                  {buttonLabel}
                </Button.Filled>
              </Flex>
            </Box>
          </DialogContainer>
        </Overlay>
      )}
    </Transition>
  )
}

Dialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  buttonLabel: PropTypes.string.isRequired,
}

const Narrow = (props) => <Dialog {...props} maxWidth={pxToRem(500)} />

Dialog.Narrow = Narrow

export default Dialog
